import CityPageTemplate from "../city-template/CityPageTemplate";
import { sitkaConfig } from "./data";

export default function SitkaPage() {
  return <CityPageTemplate config={sitkaConfig} />;
}